module.exports = __webpack_public_path__ + "img/icon_list_good_normal.8b64e7b3.svg";